import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import { useNavigate } from "react-router";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { BsArrowRightShort } from "react-icons/bs";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import Pagination from "../../../Components/layouts/pagination";
import { FcSurvey } from "react-icons/fc";
import StepRoutes from "../../../Routes/steps_routes";


const tableHead = ["Sr.", "Expense Type", "Category", "Amount", "Actions"];
const ViewExpenditure = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    expenseType: "",
  });
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);

  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    performRequest("GET", "/financial/get-alldata")
      .then((res) => {
        setData(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL(`/financial/get-alldata`, page, filters)
    )
      .then((res) => {
        setData(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [filters, refresh]);

  const handleSubmit = (values) => {
    performRequest("PATCH", `/financial/update-financials/`, values)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          Toast("success", "Expenditure Updated Successfully!");
          window.location.reload();
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="page-header d-print-none">
                <div className="col-12 mb-4 d-flex">
                  <div className="col">
                    <h2 className="page-title mb-1"> <FcSurvey className="fs-2 me-1" /> Update Expense Tracking</h2>
                    <h4 className="text-muted"> 
                      <StepRoutes />
                      </h4>
                  </div>
                  <div className="">
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate("/financial-dashboard")}
                    >
                      Home
                    </button>
                    <button
                      className="btn btn-primary ms-2"
                      onClick={() => navigate("/add-financial-expense")}
                    >
                      Add Expenditure
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-12 d-md-flex">
                  <div className="col-md-3 col-sm-12 py-2">
                    <div className="card p-2">
                      <div
                        id="faq-1"
                        className="accordion"
                        role="tablist"
                        aria-multiselectable="true"
                      >
                        <div>
                          <div className="accordion-header m-0" role="tab">
                            <button
                              className="accordion-button fs-3 d-md-none p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq-1-1"
                            >
                              <h3 className="m-1">Filter result</h3>
                            </button>
                          </div>

                          <div
                            id="faq-1-1"
                            className="accordion-collapse collapse d-md-none"
                            role="tabpanel"
                            data-bs-parent="#faq-1"
                          >
                            <div className="accordion-body pt-0">
                              <div className="row">
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Expense Type:"
                                    value={filters.expenseType}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        expenseType: e.target.value,
                                      })
                                    }
                                    type="text"
                                  >
                                    <option value="">Select</option>
                                    <option value="recurring">Recurring</option>
                                    <option value="fixed">Fixed</option>
                                    <option value="variable">Variable</option>
                                    <option value="marketing">Marketing</option>
                                    <option value="adHoc">Adhoc</option>
                                  </DynamicFilterSelect>
                                </div>
                                <div className="col-12">
                                  <DynamicFilterInput
                                    label="Entry Date:"
                                    value={filters.startdate}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        startdate: e.target.value,
                                      })
                                    }
                                    type="date"
                                  />
                                </div>

                                <div className="col-12">
                                  <div className="row mt-2">
                                    <div className="col-6">
                                      <button
                                        onClick={() => setRefresh(!refresh)}
                                        className="btn btn-success w-100"
                                      >
                                        Apply Filter
                                      </button>
                                    </div>
                                    <div className="col-6">
                                      <button
                                        onClick={() => {
                                          setFilters({
                                            expenseType: "",
                                            enddate: "",
                                            name: "",
                                            paymentStatus: "",
                                            webinarId: "",
                                          });
                                          setRefresh(!refresh);
                                        }}
                                        className="btn btn-secondary w-100"
                                      >
                                        Reset Filter
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="accordion-body d-none d-md-block">
                            <div className="row">
                              <h3>Filter result</h3>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Expense Type:"
                                  value={filters.expenseType}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      expenseType: e.target.value,
                                    })
                                  }
                                  type="text"
                                >
                                  <option value="">Select</option>
                                  <option value="recurring">Recurring</option>
                                  <option value="fixed">Fixed</option>
                                  <option value="variable">Variable</option>
                                  <option value="marketing">Marketing</option>
                                  <option value="adHoc">Adhoc</option>
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Entry Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          expenseType: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-9 col-sm-12 py-2 ms-2">
                    <div className="table-responsive border-top border border-1">
                      <table className="table table-vcenter">
                        <thead>
                          <tr>
                            {tableHead?.map((item, index) => {
                              return <th key={index}>{item}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.map((item, index) => {
                            const Index = index + 1;
                            return (
                              <tr key={item?.id}>
                                <td>{Index}</td>

                                <td>
                                  {item?.expenseType
                                    ? item?.expenseType.name
                                        .charAt(0)
                                        .toUpperCase() +
                                      item?.expenseType.name.slice(1)
                                    : "N/A"}
                                </td>
                                <td>{item?.category || "N/A"}</td>
                                <td>{item?.amount || "N/A"}</td>

                                <td>
                                  <button
                                    className="btn btn-sm px-3 btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#creditNote"
                                    onClick={() => {
                                      setFormData(item);
                                    }}
                                    disabled={loading}
                                  >
                                    <BsArrowRightShort className="me-1" /> View
                                    & Edit
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="col-md-12 col-lg-12 col-sm-12">
                      <div className="card">
                        <Pagination
                          page={page}
                          setPage={setPage}
                          totalPages={totalPages}
                          pageDatalength={data?.length}
                          showPage={showPage}
                          setShowPage={setShowPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      {/*  view modal  */}

      <div
        className="modal fade "
        id="creditNote"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable "
          style={{ maxWidth: "800px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Expenditure</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="btn-close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="card-body">
                {/* Expenditure Type */}
                <div className="mb-3 row">
                  <label className="w-25 form-label required col-3">
                    Expenditure Type
                  </label>
                  <div className="w-100 col">
                    <input
                      className="form-control"
                      placeholder="Expenditure Type"
                      autoComplete="off"
                      name="expenditureType"
                      value={formData?.expenseType.name}
                      type="text"
                      disabled
                    />
                  </div>
                </div>

                <div className="mb-3 row">
                  <label className="w-25 form-label required col-3">
                    Category
                  </label>
                  <div className="w-100 col">
                    <input
                      className="form-control"
                      placeholder="Category"
                      autoComplete="off"
                      name="category"
                      value={formData?.category}
                      type="text"
                      disabled
                    />
                  </div>
                </div>

                {/* Description */}
                <div className="mb-3 row">
                  <label className="w-25 form-label required col-3">
                    Description
                  </label>
                  <div className="w-100 col">
                    <input
                      className="form-control"
                      placeholder="Description"
                      autoComplete="off"
                      value={formData?.description}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          description: e.target.value,
                        });
                      }}
                      name="description"
                      type="text"
                    />
                  </div>
                </div>
                {/* Amount */}
                <div className="mb-3 row">
                  <label className="w-25 form-label required col-3">
                    Amount
                  </label>
                  <div className="w-100 col">
                    <input
                      className="form-control"
                      placeholder="Amount"
                      autoComplete="off"
                      value={formData?.amount}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          amount: e.target.value,
                        });
                      }}
                      name="amount"
                      type="number"
                    />
                  </div>
                </div>
                {/* Entry Date */}
                <div className="mb-3 row">
                  <label className="w-25 form-label required col-3">
                    Entry Date
                  </label>
                  <div className="w-100 col">
                    <input
                      className="form-control"
                      placeholder="Amount"
                      autoComplete="off"
                      disabled
                      value={formData?.entryDate}
                      name="entryDate"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  handleSubmit(formData);
                }}
                data-bs-dismiss="modal"
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewExpenditure;
